@if (!hideSiteHeader()) {
  <app-header />
}
<main id="main-content" class="lf-app-main">
  <router-outlet />
</main>
@if (!hideSiteFooter()) {
  <app-footer />
}
<app-bag-drawer />
@if (cartService.isNavigatingToCheckout()) {
  <app-page-loader variant="page" message="Taking you to checkout…" />
}
